<mat-toolbar color="accent">
  <button id="goToPanelButtonShowEdit" mat-icon-button (click)="goToPanel()">
    <mat-icon class="icon-ic_arrow_back" color="secundary"></mat-icon>
  </button>
  <span> {{ (isVideoSelfing ? 'videoselfing.title' : 'ine.title') | translate }}</span>
</mat-toolbar>

<mat-card>
  <h2>{{ 'request.header.title' | translate }} {{ numOperation }}</h2>
  <p>{{ (isVideoSelfing ? 'videoselfing.subtitle' : 'ine.subtitle') | translate }}</p>
  <div>
    <form [formGroup]="pendingForm">
      <div class="table__wrapper">
        <table aria-label="ine-signature" mat-table [dataSource]="dataSource.data">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td
              mat-cell
              *matCellDef="let element"
              [class.disabled]="
                element.ineSigned || element.onfidoProcess == 'DECLINED' || element.onfidoProcess == 'REVIEW'
              "
            >
              <mat-radio-group formControlName="pending">
                <mat-radio-button
                  *ngIf="!element.ineSigned && element.onfidoProcess != 'DECLINED' && element.onfidoProcess != 'REVIEW'"
                  (click)="$event.stopPropagation()"
                  (change)="checkValue($event)"
                  [checked]="selection.isSelected(element)"
                  [value]="element"
                >
                </mat-radio-button>
              </mat-radio-group>
            </td>
          </ng-container>
          <ng-container matColumnDef="physicalId">
            <th mat-header-cell *matHeaderCellDef translate>ine.dni</th>
            <td
              mat-cell
              *matCellDef="let element"
              [class.disabled]="
                element.ineSigned || element.onfidoProcess == 'DECLINED' || element.onfidoProcess == 'REVIEW'
              "
            >
              {{ element.physicalId }}
            </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef translate>ine.name</th>
            <td
              mat-cell
              *matCellDef="let element"
              [class.disabled]="
                element.ineSigned || element.onfidoProcess == 'DECLINED' || element.onfidoProcess == 'REVIEW'
              "
            >
              {{ element.name }}
            </td>
          </ng-container>
          <ng-container matColumnDef="firstSurname">
            <th mat-header-cell *matHeaderCellDef translate>ine.lastname</th>
            <td
              mat-cell
              *matCellDef="let element"
              [class.disabled]="
                element.ineSigned || element.onfidoProcess == 'DECLINED' || element.onfidoProcess == 'REVIEW'
              "
            >
              {{ element.firstSurname }}
            </td>
          </ng-container>
          <ng-container matColumnDef="lastSurname">
            <th mat-header-cell *matHeaderCellDef translate>ine.lastname2</th>
            <td
              mat-cell
              *matCellDef="let element"
              [class.disabled]="
                element.ineSigned || element.onfidoProcess == 'DECLINED' || element.onfidoProcess == 'REVIEW'
              "
            >
              {{ element.lastSurname }}
            </td>
          </ng-container>
          <ng-container matColumnDef="ineSigned">
            <th mat-header-cell *matHeaderCellDef>
              {{ (isVideoSelfing ? 'videoselfing.accept' : 'ine.accept') | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              [class.disabled]="
                element.ineSigned || element.onfidoProcess == 'DECLINED' || element.onfidoProcess == 'REVIEW'
              "
            >
              {{ element.ineSigned === true ? 'SI' : 'NO' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="smsAttempts">
            <th mat-header-cell *matHeaderCellDef translate>ine.attempls</th>
            <td
              mat-cell
              *matCellDef="let element"
              [class.disabled]="
                element.ineSigned || element.onfidoProcess == 'DECLINED' || element.onfidoProcess == 'REVIEW'
              "
            >
              {{ element.smsAttempts }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </form>
    <ng-template [ngIf]="selectedValue?.smsAttempts === 0">
      <div class="error_div" fxLayout="row" fxLayoutAlign="center" translate>
        {{ 'ine.message' | translate }}
      </div>
    </ng-template>
  </div>
</mat-card>
<div class="buttons" fxLayoutAlign="end start" fxLayoutGap="16px">
  <button
    mat-flat-button
    color="accent"
    [disabled]="!pendingForm.valid || selectedValue?.ineSigned"
    *ngIf="!isVideoSelfing"
    (click)="print()"
  >
    <mat-icon class="icon-ic_print"></mat-icon>
    <span>{{ 'ine.print' | translate | uppercase }}</span>
  </button>
  <button
    mat-flat-button
    color="accent"
    [disabled]="!pendingForm.valid || selectedValue?.smsAttempts === 0 || (selectedValue?.ineSigned && !isVideoSelfing)"
    (click)="sendSMS()"
  >
    <mat-icon class="message"></mat-icon>
    <span>{{ 'ine.sms' | translate | uppercase }}</span>
  </button>
</div>
